import * as React from 'react';

import classnames from 'classnames';

import {HelpButton} from '../help/help-button';
import {Popover} from '../popover/popover';

import styles from './popover-info.module.css';

export type PopoverInfoProps = {
    info: string | React.ReactNode;
    size?: number;
    variant?: 'error' | 'green' | 'blue';
    bodyColor?: 'light' | 'dark' | 'error';
    noIconPadding?: boolean;
    shouldFadeIn?: boolean;
};

PopoverInfo.defaultProps = {
    bodyColor: 'light',
    shouldFadeIn: false,
};

export function PopoverInfo(props: PopoverInfoProps) {
    const [isPopoverShown, setIsPopoverShown] = React.useState<boolean>(false);
    const [iconRef, setIconRef] = React.useState<HTMLElement | null | undefined>(null);

    const {info, ...restProps} = props;

    return (
        <>
            <HelpButton
                ref={(ref) => {
                    // @ts-expect-error
                    setIconRef(ref);
                }}
                // @ts-expect-error
                noPadding={props.noIconPadding}
                size={props.size}
                variant={props.variant}
                // @ts-expect-error
                onClick={(e) => {
                    e.stopPropagation();
                    setIsPopoverShown(true);
                }}
            />
            {isPopoverShown ? (
                <Popover
                    {...restProps}
                    anchor={iconRef}
                    onBlur={(e) => {
                        e.stopPropagation();
                        setIsPopoverShown(false);
                    }}
                    bodyColor={props.bodyColor}
                    shouldFadeIn={props.shouldFadeIn}
                >
                    <div
                        onClick={(e) => {
                            e.stopPropagation(); // Prevent click inside popover from bubbling up
                        }}
                        className={classnames('pad-16', styles['popover-text'])}
                    >
                        {info}
                    </div>
                </Popover>
            ) : undefined}
        </>
    );
}
